export const GET_STATUS = 'GET_STATUS';
export const GET_STATUS_SUCCESS = 'GET_STATUS_SUCCESS';
export const GET_STATUS_FAILURE = 'GET_STATUS_FAILURE';
export const POST_PAYMENT_COMPLETED = 'POST_PAYMENT_COMPLETED';